<template>
    <BCard>
        <BRow>
            <BCol cols="12" xl="6" class="d-flex justify-content-between flex-column" >

                <div class="d-flex justify-content-start">
                    <BAvatar :text="avatarText(group.name)" size="104px" rounded />
                    <div class="d-flex flex-column ml-1">
                        <div class="mb-1">
                            <h4 class="mb-0"> {{ group.name }} </h4>
                            <span class="card-text">{{ group.email }}</span>
                        </div>
                        <div class="d-flex flex-wrap">
                            <BButton @click="showViewGroup=false; showEditGroup=true" variant="primary" v-if="ability.can('write', 'group')"> {{$t('Edit')}} </BButton>
                            <BButton variant="outline-danger" class="ml-1" @click="deletePopupAxios(selectedGroupId, `groups/${selectedGroupId}`)" v-if="ability.can('delete', 'group')"> {{$t('Delete')}} </BButton>
                        </div>
                    </div>
                </div>

            </BCol>
        </BRow>
    </BCard>
</template>

<script>
import { BCard, BRow, BAvatar, BButton, BCol } from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import { inject, onUnmounted } from '@vue/composition-api';
import popups from '@/hooks/popups';
import ability from '@/libs/acl/ability';
import store from '@/store'
import groupsStoreModule from '../groupsStoreModule'

export default {
    components: { BCard, BRow, BAvatar, BButton, BCol },
    setup(){
        const GROUPS_APP_STORE_MODULE_NAME = 'groups'
        const { deletePopupAxios } = popups()
        const group = inject('group')
        const showListGroup = inject('showListGroup')
        const showViewGroup = inject('showViewGroup')
        const showEditGroup = inject('showEditGroup')
        const selectedGroupId = inject('selectedGroupId')

        const refetchData = () => {
            showViewGroup.value = false
            showListGroup.value = true
        }
        
        if (!store.hasModule(GROUPS_APP_STORE_MODULE_NAME)) store.registerModule(GROUPS_APP_STORE_MODULE_NAME, groupsStoreModule)
        onUnmounted(() => { if (store.hasModule(GROUPS_APP_STORE_MODULE_NAME)) store.unregisterModule(GROUPS_APP_STORE_MODULE_NAME) })
        return {

            deletePopupAxios,
            avatarText,
            ability,
            group,
            selectedGroupId,
            showListGroup,
            showEditGroup,
            showViewGroup,
            refetchData
        }
    }
}
</script>

<style>

</style>